// eslint-disable-next-line
export default new (class InfographicModel {
  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.documentId = data.documentId || "";
    model.title = data.Title || {};
    model.description = data.description || {};
    model.slug = data.Slug || "";
    model.tag = data.tag || [];
    model.publisher = data.publisher || null;
    // ภาพทั้งหมดตามลำดับใน Image — ภาพแรกเป็นหน้าปกการ์ด หน้ารายละเอียดโชว์ทุกภาพแบบสไลด์
    model.images = Array.isArray(data.Image?.image) ? data.Image.image : [];
    model.createdAt = data.createdAt || "";
    model.publishedAt = data.publishedAt || "";

    return model;
  }
})();
